import { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useAssessment } from "../components/assessmentContext";
import { useNavigate, useLocation } from "react-router-dom";
import { Get_AssessmentData_by_Method } from "../apis/services/csaApi";
import QuestionGroup from "./QuestionGroup"; // New component we'll
import en from "../json/en.json";
import ch from "../json/ch.json";

export default function Questionnaires() {
  const lId = localStorage.getItem("languageId") || "1";

  const navigate = useNavigate();
  const location = useLocation();
  const activeTabHome = location.state?.activeTabHome ?? 0;
  const [openPanels, setOpenPanels] = useState({});
  const { activeAssessment } = useAssessment();
  const [activeTab, setActiveTab] = useState(activeTabHome || 0);
  const phaseRefs = useRef({});
  const [transformedData, setTransformedData] = useState([]);
  const [openGroupId, setOpenGroupId] = useState(null);

  // const handleRadioChange = () => {
  //   Get_AssessmentData_by_Method(
  //     "segmentation",
  //     localStorage.getItem("languageId"),
  //     localStorage.getItem("userName"),
  //     localStorage.getItem("AssessmentId")
  //   ).then((rawData) => {
  //     console.log("rawData", rawData);

  //     if (rawData && rawData.length > 0) {
  //       // Group data by method
  //       const methods = [...new Set(rawData.map((item) => item.method))];

  //       const transformed = methods.map((method) => {
  //         const methodData = rawData.filter(item => item.method === method);
  //         // Calculate method totals
  //         const methodCurrentTotal = methodData.reduce((sum, item) => sum + (item.currentScore || 0), 0);
  //         const methodDesiredTotal = methodData.reduce((sum, item) => sum + (item.desiredScore || 0), 0);
  //         console.log("methodCurrentTotal", methodCurrentTotal);
  //         console.log("methodDesiredTotal", methodDesiredTotal);
  //         // Get all phases for this method
  //         const methodPhases = [
  //           ...new Set(
  //             rawData
  //               .filter((item) => item.method === method)
  //               .map((item) => item.phase)
  //           ),
  //         ];

  //         const topicDetails = methodPhases.map((phase) => {
  //           // Get all groups for this phase
  //           const phaseGroups = [
  //             ...new Set(
  //               rawData
  //                 .filter(
  //                   (item) => item.method === method && item.phase === phase
  //                 )
  //                 .map((item) => item.groupName)
  //             ),
  //           ];

  //           const details = phaseGroups.map((groupName) => {
  //             const groupItems = rawData.filter(
  //               (item) =>
  //                 item.method === method &&
  //                 item.phase === phase &&
  //                 item.groupName === groupName
  //             );

  //             // Get the first item for group-level data (assuming all items in group have same metadata)
  //             const firstItem = groupItems[0] || {};

  //             return {
  //               qid: firstItem.id,
  //               groupname: groupName,
  //               questionNum: `${firstItem.completedQuestions}/${firstItem.totalQuestions}`,
  //               completion: `${firstItem.completionPercentage}%`,
  //               currentScore: firstItem.currentScore,
  //               desiredScore: firstItem.desiredScore,
  //               currentReach: firstItem.currentReach,
  //               desiredReach: firstItem.desiredReach,
  //               groupId: firstItem.groupId,
  //               enablers: firstItem.enablers,
  //               questions: groupItems.map((item) => item.questions),
  //               allGroupItems: groupItems, // Store all items for this group
  //               method: method,
  //               phase: phase,
  //             };
  //           });

  //           return {
  //             phase: phase,
  //             details: details,
  //           };
  //         });

  //         return {
  //           topics: method,
  //           methodCurrentTotal: methodCurrentTotal,
  //           methodDesiredTotal: methodDesiredTotal,
  //           topicDetails: topicDetails,
  //         };
  //       });
  //       console.log("transformed", transformed);
  //       setTransformedData(transformed);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   handleRadioChange();
  // }, [localStorage.getItem("AssessmentId")]);

  const [methodTotals, setMethodTotals] = useState([]);

  const handleTabChange = (index) => {
    navigate(location.pathname, { replace: true, state: null });
    // console.log("index", index);
    // console.log("transformed", transformedData);
    setActiveTab(index);
    setOpenPanels({});
    setOpenGroupId(null);
    handleRadioChange(index);
    handleRadioChangeLiveScoreUpdate(index);
  };

  const handleRadioChange = (index) => {
    // console.log("index", index);

    const methods = ["segmentation", "rgm", "rtm", "pace", "execution", "cvc"];
    // const methods = ["css",  "rtm"];
    const defaultMethod = methods[index] || "segmentation"; // fallback to 'segmentation' if index out of bounds    const methodToFetch = location.state?.method || defaultMethod;
    // const defaultMethod = methods[index] || "css";
    const methodToFetch =
      methods[location.state?.activeTab - 1] || defaultMethod;

    Get_AssessmentData_by_Method(
      methodToFetch, // Dynamic method parameter
      localStorage.getItem("languageId"),
      localStorage.getItem("userName"),
      localStorage.getItem("AssessmentId")
    ).then((rawData) => {
      if (rawData && rawData.length > 0) {
        // The first array contains detailed data, the second contains method totals
        const detailedData = rawData[0];
        const totalsData = rawData[1];

        // Store method totals for tab display
        setMethodTotals(totalsData);

        // Transform the detailed data
        const methods = [...new Set(detailedData.map((item) => item.method))];

        const transformed = methods.map((method) => {
          // Find the totals for this method
          const methodTotal = totalsData.find((m) => m.method === method) || {};

          // Get all phases for this method
          const methodPhases = [
            ...new Set(
              detailedData
                .filter((item) => item.method === method)
                .map((item) => item.phase)
            ),
          ];
          // console.log("methodPhases", methodPhases);

          const topicDetails = methodPhases.map((phase) => {
            // Get all groups for this phase
            const phaseGroups = [
              ...new Set(
                detailedData
                  .filter(
                    (item) => item.method === method && item.phase === phase
                  )
                  .map((item) => item.groupName)
              ),
            ];

            const details = phaseGroups.map((groupName) => {
              const groupItems = detailedData.filter(
                (item) =>
                  item.method === method &&
                  item.phase === phase &&
                  item.groupName === groupName
              );

              // Get the first item for group-level data
              const firstItem = groupItems[0] || {};

              return {
                // question_Seq: firstItem.question_Seq,
                qid: firstItem.id,
                groupname: groupName,
                groupName_EN: firstItem.groupName_EN,
                questionNum: `${firstItem.completedQuestions}/${firstItem.totalQuestions}`,
                completion: `${firstItem.completionPercentage}%`,
                currentScore: firstItem.currentScore,
                desiredScore: firstItem.desiredScore,
                currentReach: firstItem.currentReach,
                desiredReach: firstItem.desiredReach,
                groupId: firstItem.groupId,
                enablers: firstItem.enablers,
                questions: groupItems.map((item) => item.questions),
                allGroupItems: groupItems,
                method: method,
                phase: phase,
              };
            });

            return {
              phase: phase,
              details: details,
            };
          });

          return {
            topics: method,
            methodCurrentTotal: methodTotal.currentTotal || 0,
            methodDesiredTotal: methodTotal.desiredTotal || 0,
            topicDetails: topicDetails,
          };
        });
        console.log("transformed", transformed);

        setTransformedData(transformed);

        // Set active tab if coming from navigation
        if (location.state?.method) {
          const methodIndex = totalsData.findIndex(
            (m) => m.method === location.state.method
          );
          if (methodIndex !== -1) {
            setActiveTab(methodIndex);
          }
        }
      }
    });
  };

  const handleRadioChangeLiveScoreUpdate = (index) => {
    // console.log("index1", index);

    const methods = ["segmentation", "rgm", "rtm", "pace", "execution", "cvc"];
    // const methods = ["css", "rtm"];
    const defaultMethod = methods[index] || "segmentation"; // fallback to 'segmentation' if index out of bounds    const methodToFetch = location.state?.method || defaultMethod;
    // const defaultMethod = methods[index] || "css";
    const methodToFetch =
      methods[location.state?.activeTab - 1] || defaultMethod;

    Get_AssessmentData_by_Method(
      methodToFetch, // Dynamic method parameter
      localStorage.getItem("languageId"),
      localStorage.getItem("userName"),
      localStorage.getItem("AssessmentId")
    ).then((rawData) => {
      if (rawData && rawData.length > 0) {
        // The first array contains detailed data, the second contains method totals
        const detailedData = rawData[0];
        const totalsData = rawData[1];

        // Store method totals for tab display
        setMethodTotals(totalsData);

        // Transform the detailed data
        const methods = [...new Set(detailedData.map((item) => item.method))];

        const transformed = methods.map((method) => {
          // Find the totals for this method
          const methodTotal = totalsData.find((m) => m.method === method) || {};

          // Get all phases for this method
          const methodPhases = [
            ...new Set(
              detailedData
                .filter((item) => item.method === method)
                .map((item) => item.phase)
            ),
          ];

          const topicDetails = methodPhases.map((phase) => {
            // Get all groups for this phase
            const phaseGroups = [
              ...new Set(
                detailedData
                  .filter(
                    (item) => item.method === method && item.phase === phase
                  )
                  .map((item) => item.groupName)
              ),
            ];

            const details = phaseGroups.map((groupName) => {
              const groupItems = detailedData.filter(
                (item) =>
                  item.method === method &&
                  item.phase === phase &&
                  item.groupName === groupName
              );

              // Get the first item for group-level data
              const firstItem = groupItems[0] || {};

              return {
                // question_Seq: firstItem.question_Seq,
                qid: firstItem.id,
                groupname: groupName,
                questionNum: `${firstItem.completedQuestions}/${firstItem.totalQuestions}`,
                completion: `${firstItem.completionPercentage}%`,
                currentScore: firstItem.currentScore,
                desiredScore: firstItem.desiredScore,
                currentReach: firstItem.currentReach,
                desiredReach: firstItem.desiredReach,
                groupId: firstItem.groupId,
                enablers: firstItem.enablers,
                questions: groupItems.map((item) => item.questions),
                allGroupItems: groupItems,
                method: method,
                phase: phase,
              };
            });

            return {
              phase: phase,
              details: details,
            };
          });

          return {
            topics: method,
            methodCurrentTotal: methodTotal.currentTotal || 0,
            methodDesiredTotal: methodTotal.desiredTotal || 0,
            topicDetails: topicDetails,
          };
        });
        // console.log("transformed", transformed);

        setTransformedData(transformed);

        //     // Set active tab if coming from navigation
        //     if (location.state?.method) {
        //       const methodIndex = totalsData.findIndex(m => m.method === location.state.method);
        //       if (methodIndex !== -1) {
        //         setActiveTab(methodIndex);
        //       }
        //     }
      }
    });
  };

  useEffect(() => {
    handleRadioChange();
  }, [localStorage.getItem("AssessmentId"), location.state?.activeTab]);

  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab - 1);
    }
    if (location.state?.openPhase) {
      const { openPhase, openGroup, openEnabler } = location.state;
      setOpenPanels({ [openPhase]: true });
      // console.log(`Opening phase: ${openPhase}, group: ${openGroup}, enabler: ${openEnabler}`);
      const currentMethod = transformedData[0];
      // console.log("currentMethod", currentMethod);
      if (currentMethod) {
        const phaseData = currentMethod.topicDetails.find(
          (p) => p.phase === openPhase
        );
        if (phaseData) {
          const groupData = phaseData.details.find(
            (g) => g.groupname === openGroup
          );
          setOpenGroupId(groupData?.groupId || null);
          if (groupData) {
            // Set the group to open after a small delay to allow the phase to open
            setTimeout(() => {
              setCurrentOpenEnabler(openEnabler);
              // Scroll to the phase
              const target = phaseRefs.current[openPhase];
              if (target) {
                const yOffset = -100;
                const y =
                  target.getBoundingClientRect().top +
                  window.pageYOffset +
                  yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }, 300);
          }
        }
      }
    }
  }, [location.state, transformedData]);

  // Add currentOpenEnabler state and pass it to QuestionGroup
  const [currentOpenEnabler, setCurrentOpenEnabler] = useState(
    "Human Talent & Organization"
    // "Standardized Process & Governance"
    // lId==="1"?en.HumanTalentnOrganization:ch.HumanTalentnOrganization
    // lId==="1"?en.StandardizedProcessnGovernance:ch.StandardizedProcessnGovernance
    // lId==="1"?en.ToolsnTechnology:ch.ToolsnTechnology
  );

  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    }

    if (location.state?.openPhase) {
      const openPhase = location.state.openPhase;
      setOpenPanels((prev) => ({
        ...prev,
        [openPhase]: true,
      }));

      setTimeout(() => {
        const target = phaseRefs.current[openPhase];
        if (target) {
          const yOffset = -100;
          const y =
            target.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);
    }
  }, [location.state]);

  const triggerRef = useRef();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 1,
        rootMargin: "-35px 0px 0px 0px",
      }
    );

    if (triggerRef.current) observer.observe(triggerRef.current);

    return () => observer.disconnect();
  }, []);

  const togglePanel = (phase) => {
    setOpenPanels((prevState) => ({
      ...prevState,
      [phase]: !prevState[phase],
    }));
    // Close any open group when closing a phase
    if (!openPanels[phase]) {
      setOpenGroupId(null);
    }
  };

  const toggleGroup = (groupId) => {
    // setCurrentOpenEnabler("Human Talent & Organization");
    // setCurrentOpenEnabler("Standardized Process & Governance");
    // setCurrentOpenEnabler("Tools & Technology");
    setCurrentOpenEnabler(
      lId === "1"
        ? en.StandardizedProcessnGovernance
        : ch.StandardizedProcessnGovernance
    );
    setOpenGroupId((prev) => (prev === groupId ? null : groupId));
  };

  const [modalData, setModalData] = useState({
    isOpen: false,
    imageSrc: null,
    title: null,
  });

  const openImageModal = (src, title = null) => {
    setModalData({ isOpen: true, imageSrc: src, title });
  };

  const closeModal = () => {
    setModalData({ isOpen: false, imageSrc: null, title: null });
  };

  useEffect(() => {
    if (modalData.isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [modalData.isOpen]);

  return (
    <div className="wrapper">
      <div className="section-questions">
        <h1 className="main-heading">
          {transformedData[0]?.topics || "Loading..."}{" "}
          {localStorage.getItem("AssessmentText")}{" "}
          {lId === "1" ? en.breakdown : ch.breakdown}
        </h1>

        {/* Tabs */}
        {/* <div className="methods-container">
          {transformedData.map((method, index) => (
            <button
              key={index}
              onClick={() => handleTabChange(index)}
              className={`methods ${activeTab === index ? "active" : ""}`}
            >
              <div className="score-section">
                <img src={`/assets/main/methodIcon-${index + 1}.svg`} alt="" />
                <span>{method.methodCurrentTotal} / {method.methodDesiredTotal}</span>
              </div>
              <p>{method.topics}</p>
            </button>
          ))}
        </div> */}
        <div className="methods-container">
          {methodTotals.map((method, index) => (
            <button
              key={index}
              onClick={() => {
                navigate(location.pathname, {
                  replace: true,
                  state: { ...location.state, method: method.method },
                });
                handleTabChange(index);
              }}
              className={`methods ${activeTab === index ? "active" : ""}`}
            >
              <div className="score-section">
                <img src={`/assets/main/methodIcon-${index + 1}.svg`} alt="" />
                <span>
                  {method.currentTotal} | {method.desiredTotal}
                </span>
              </div>
              <p>{method.method}</p>
            </button>
          ))}
        </div>
        <div ref={triggerRef} className="h-1" />

        {/* Table Overview */}
        <div className={`table-overview ${isSticky ? "sticky" : ""}`}>
          <p>
            {lId === "1" ? en.question : ch.question} <span>(#)</span>
          </p>
          <p className={lId === "1" ? "pen" : "pch"}>
            {lId === "1" ? en.completion : ch.completion} <span>(%)</span>
          </p>
          <p className={lId === "1" ? "pen" : "pch"}>
            {lId === "1" ? en.currentScore : ch.currentScore}
          </p>
          <p
            className={lId === "1" ? "pen" : "pch"}
          >
            {lId === "1" ? en.desiredScore : ch.desiredScore}
          </p>
        </div>

        {/* Content */}
        <div className="methods-content-container">
          <ul>
            {/* {transformedData[activeTab]?.topicDetails?.map((faq, idx) => ( */}
            {transformedData[0]?.topicDetails?.map((faq, idx) => (
              <li key={idx} ref={(el) => (phaseRefs.current[faq.phase] = el)}>
                <div>
                  <button
                    className="outer-button"
                    onClick={() => togglePanel(faq.phase)}
                  >
                    <p className="phase">{faq.phase}</p>
                    <ChevronDownIcon
                      className={`faq-arrow transition-transform duration-200 ${
                        openPanels[faq.phase] ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {openPanels[faq.phase] && (
                    <div className="group-name-container">
                      {faq.details.map((item, itemIdx) => (
                        <div key={itemIdx}>
                          <div
                            className={`table-overview ${
                              itemIdx + 1 === item.groupId ? "active" : ""
                            }`}
                          >
                            <div className="table-overview-groupname">
                              <p onClick={() => toggleGroup(item.groupId)}>
                                {item.groupname}
                              </p>
                              {/* <span
                                onClick={() =>
                                  setModalData({
                                    isOpen: true,
                                    imageSrc: `/assets/elements/${item.groupname}.svg`,
                                    imageSrc: `/assets/elements/${lId === "1" ? item.groupname : item.groupName_EN}.svg`,
                                    title: item.groupname,
                                    title:  item.groupname,
                                  })
                                }
                                className="i-container"
                              >
                                <span className="i">i</span>
                              </span> */}

                              {/* <span
                                onClick={() =>
                                  setModalData({
                                    isOpen: true,
                                    imageSrc: `/assets/${lId === "1" ? 'elements' : 'elements_cn'}/${lId === "1" ?
                                      item.groupname.replace(/\//g, ',') :
                                      item.groupName_EN.replace(/\//g, ',')}.svg`,
                                    title: item.groupname,
                                  })
                                }
                                className="i-container"
                              >
                                <span className="i">i</span>
                              </span> */}

                              <span
                                onClick={() => {
                                  const groupName =
                                    lId === "1"
                                      ? item.groupname
                                          .replace(/^#\s+/, "")
                                          .replace(/\//g, " ")
                                      : item?.groupName_EN
                                          ?.replace(/^#\s+/, "")
                                          .replace(/\//g, " ");

                                  setModalData({
                                    isOpen: true,
                                    imageSrc: `/assets/${
                                      lId === "1" ? "elements" : "elements_cn"
                                    }/${groupName}.svg`,
                                    title: item.groupname,
                                  });
                                }}
                                className="i-container"
                              >
                                <span className="i">i</span>
                              </span>

                              {/* <span
                                style={{ right: -40 }}
                                onClick={() =>
                                  setModalData({
                                    isOpen: true,
                                    imageSrc: null,
                                    // title: item.groupname,
                                    title: "Definition",
                                  })
                                }
                                className="i-container"
                              >
                                <span className="i">D</span>
                              </span> */}
                            </div>
                            <p>{item.questionNum}</p>
                            <p>{item.completion}</p>
                            <p>
                              {item.currentScore}
                              {/* ({item.currentReach}%) */}
                            </p>
                            <p>
                              {item.desiredScore}
                              {/* ({item.desiredReach}%) */}
                            </p>
                          </div>

                          {openGroupId === item.groupId && (
                            <QuestionGroup
                              groupData={item}
                              topic={transformedData[0].topics}
                              phase={faq.phase}
                              activeTab={activeTab}
                              onClose={() => setOpenGroupId(null)}
                              initialOpenEnabler={currentOpenEnabler}
                              onRadioChange={handleRadioChangeLiveScoreUpdate}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {modalData.isOpen && (
        <div className="modal-container">
          <div
            className="modal"
            style={{ width: !modalData.imageSrc ? "600px" : "auto" }}
          >
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            {/* {modalData.title && (
              <h2 className="text-3xl font-bold mb-4">{modalData.title}</h2>
            )} */}
            {modalData.imageSrc && (
              <img
                src={modalData.imageSrc}
                alt="Modal content"
                className="modal-img"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
